import { useMyTickets } from 'library/hooks/events';
import * as st from './styles.module.scss';

export const JoinBtn = (): JSX.Element => {
  const { onBuy } = useMyTickets();
  return (
    <button className={st.wrapper} onClick={onBuy}>
      Участвовать
    </button>
  );
};
